import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/pixelcut-export-2.jpeg"; // Replace with the actual path to your logo
import "./styles/Navbar.scss";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation(); // Get the current route

  // Function to handle scroll event
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const windowHeight = window.innerHeight; // Viewport height
    const documentHeight = document.documentElement.scrollHeight; // Total height of the page
    const isAtBottom = currentScrollY + windowHeight >= documentHeight - 10; // Add a small buffer for accuracy

    if (currentScrollY > 50) {
      setScrolled(true);

      if (currentScrollY > lastScrollY && !isAtBottom) {
        // Scrolling down and not at the bottom
        setHidden(true);
      } else {
        // Scrolling up
        setHidden(false);
      }
    } else {
      setScrolled(false);
      setHidden(false); // Show navbar when at the top
    }

    setLastScrollY(currentScrollY);
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <header
      className={`navbar ${scrolled ? "scrolled" : ""} ${
        hidden ? "hidden" : ""
      }`}
    >
      <div className="logo-container">
        <NavLink to="/" onClick={handleLogoClick}>
          <img src={logo} alt="Del's Music Foundation Logo" className="logo" />
        </NavLink>
      </div>

      <div className="nav-container">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          Home
        </NavLink>
        <div
          className="nav-item"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            About{" "}
            <span className={`dropdown-arrow ${dropdownOpen ? "open" : ""}`}>
              &#9662;
            </span>
          </NavLink>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <NavLink to="/advisoryboard" className="dropdown-item">
                Advisory Board & Mentors
              </NavLink>
            </div>
          )}
        </div>
        <NavLink
          to="/media"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          Media
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          Contact Us
        </NavLink>
        <NavLink
          to="/donations"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          Donations
        </NavLink>
      </div>
    </header>
  );
}
